export interface TextToSpeechParams {
  text: string;
  speed?: number;
  format?: 'mp3' | 'opus';
}

export async function textToSpeech({
  text,
  speed = 1.0,
  format = 'mp3',
}: TextToSpeechParams): Promise<Blob> {
  const apiUrl =
    process.env.NEXT_PUBLIC_API_URL_AI ||
    process.env.EXPO_PUBLIC_API_URL_AI ||
    'http://localhost:8000';

  const res = await fetch(
    `${apiUrl}/api/v1/voice/text-to-speech?format=${format}`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        text,
        speed,
      }),
    },
  );

  if (!res.ok) {
    let errorMessage = `Text-to-speech request failed with status ${res.status}`;
    try {
      const errorData = await res.json();
      if (errorData.message || errorData.detail) {
        errorMessage = errorData.message || errorData.detail || errorMessage;
      }
    } catch {
      // If response is not JSON, use default error message
    }
    throw new Error(errorMessage);
  }

  return await res.blob();
}
